import { Flex } from "@mantine/core";
import { ErrorBoundary } from "react-error-boundary";
import { CustomerPanel } from "@/customer-panel";
import { MockCustomerPanel } from "@/customer-panel/components/customer-panel/MockCustomerPanel";
import type { ExpertUniversitySimulatedVoiceTask } from "@/expert-university";
import { RenderError } from "@/shared-utils";

interface WorkspaceContentRightSidebarSlotProps {
    customerSession: boolean;
    customerPanelEnabled: boolean;
    activeExpertUniversityTask: ExpertUniversitySimulatedVoiceTask | null;
}

export function WorkspaceContentRightSidebarSlot({
    customerSession,
    customerPanelEnabled,
    activeExpertUniversityTask,
}: WorkspaceContentRightSidebarSlotProps) {
    if ((!customerSession || !customerPanelEnabled) && !activeExpertUniversityTask) {
        return null;
    }

    return (
        <Flex pos={"absolute"} inset={0}>
            {/* This error boundary is swallowing up errors. We need to have a better way to show customer panel errors while still the panel */}
            <ErrorBoundary fallback={<RenderError />}>
                {activeExpertUniversityTask ? <MockCustomerPanel /> : <CustomerPanel />}
            </ErrorBoundary>
        </Flex>
    );
}
